import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { BountyStatus, Card, CardBody, CardImg, CardText, CardTitle, TimeProgress } from '@kambria/kambria-lego';
import Utils from 'helpers/utils';
import in_progress_icon from 'static/svg/ic-closed.svg';
import moment from "moment";
import {
  Box,
  CardHeader,
  Divider,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Container,
  Typography,
  Button,


} from '@mui/material';
import { withRouter } from 'react-router-dom';
import '../../custom-home.scss';
import './packages-payment.scss';
import { I18n } from '../../../../../helpers/i18n';


class CardPackage extends React.Component {
  state = {
    teams: null,
    prize: null,
  };

  async componentDidMount() {
  }
  handleUpgradeClick = () => {
    const { id, title, priceKat, priceUsdt, totalSession, totalDay, packageMainColor, saleOffPercentage } = this.props;
    window.location.href = `/payment/${id}`;
  }
  calculateTotalSaleOffPercent = (saleOffPercentage, saleOffPercentageWithKATPayment) => {
    return 100 - (100 - saleOffPercentage) * (100 - saleOffPercentageWithKATPayment) / 100;
  }

  render() {
    const { key, title, priceOrigin, priceKat, priceUsdt, totalSession, totalDay, packageMainColor, saleOffPercentage, saleOffPercentageWithKATPayment } = this.props;

    return (
      <Card className="priceCard" >

        <Box className="sale-off-box" style={
          {
            backgroundColor: this.props.packageMainColor,
          }
        }>
          <Typography variant="" className="sale-off-text" style={{ color: 'black' }}>
            {this.calculateTotalSaleOffPercent(this.props.saleOffPercentage, this.props.saleOffPercentageWithKATPayment)}% OFF <span style={{ fontSize: 'small' }}>with KAT</span>          </Typography>
        </Box>
        <Box>
          <Typography variant="" className="price-card-name" style={{ color: this.props.packageMainColor }}>
            {this.props.title}
          </Typography>

          <br />
          <Typography variant="" className="price">
            {this.props.priceUsdt} USD&nbsp;
          </Typography>
          {this.props.saleOffPercentage !== '0' && (
            <>
              <Typography variant="" className="totalPrice">
                {this.props.priceOrigin} USD
              </Typography>
              <Typography variant="" className="price">
                &nbsp;
              </Typography>
              <Typography className="saleOffText">-{this.props.saleOffPercentage}%</Typography>
            </>
          )}

          <br />
          <Typography variant="p" className="normal">
            {I18n.t('and')}&nbsp;
          </Typography>
          <Typography variant="" className="totalSaleOff">
            {this.props.saleOffPercentage !== '0' ? I18n.t('get_extra_discount', {d: `${this.props.saleOffPercentageWithKATPayment}%`}) : I18n.t('get_discount', {d: `${this.props.saleOffPercentageWithKATPayment}%`})}
          </Typography>
          <br />
          <Typography variant="" className="price">
            {this.props.priceKat} USD
          </Typography>
          <br />
          <Typography variant="" className="normal">
            * {I18n.t('kat_pay')}
          </Typography>
        </Box>
        <Divider style={{ backgroundColor: "#505c6b" }}></Divider>
        <Box>
          <Typography variant="p" className="normal">
            {'\u2022'} {I18n.t('total_sessions_in_package', {n: this.props.totalSession})}
          </Typography>
          <br />
          <Typography variant="p" className="normal">
            {'\u2022'} {I18n.t('package_valid_time', {d: this.props.totalDay})}
          </Typography>
        </Box>
        <Button className={'buttonUpgrade'} onClick={this.handleUpgradeClick}>
          <span>{I18n.t('upgrade_package')}</span>
        </Button>

      </Card >
    );
  }
}

export default withRouter(connect(null, {})(CardPackage));
